import { render, staticRenderFns } from "./cloud.global.vue?vue&type=template&id=35a7f132&"
import script from "./cloud.global.vue?vue&type=script&lang=js&"
export * from "./cloud.global.vue?vue&type=script&lang=js&"
import style0 from "./cloud.global.vue?vue&type=style&index=0&id=35a7f132&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports